export default __webpack_public_path__ + "static/media/clipboard-data-fill.4dfd69a0.svg";